import styled from 'styled-components'

export const SelectFromEnumAsyncStyles = styled.div``
